import type * as React from 'react';

import Skeleton from 'common/components/Skeleton';
import useAreasByCompanyId from 'common/hooks/useAreasByCompanyId';
import { getTeamName } from 'common/utils/reportUtils';
import { useCurrentCompany } from 'features/sidebar';

type Props = {
  isPending?: boolean;
  skeleton?: React.ReactNode;
  team?: string;
};

const CourierTeam: React.FunctionComponent<Props> = ({ isPending, skeleton, team }) => {
  const { currentCompany } = useCurrentCompany();
  const { id: companyId } = currentCompany.data ?? {};

  const areas = useAreasByCompanyId({
    companyId,
  });

  if (isPending || areas.isPending) {
    return skeleton ?? <Skeleton $width="3rem" $height="0.9rem" />;
  }

  return team ? (getTeamName(team, areas.data) ?? team) : null;
};

export default CourierTeam;
